import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';

/**
 * 物件スライダーを初期化する
 *
 * @param {Object} config
 * @param {string} config.sliderSelector - スライダーのセレクタ
 * @param {string} config.prevEl - 前へボタンのセレクタ
 * @param {string} config.nextEl - 次へボタンのセレクタ
 * @param {Object} [config.sp] - SP用のオプション上書き
 * @param {Object} [config.pc] - PC用のオプション上書き
 * @returns {Swiper|null}
 */
export function initEstateSlider(config) {
    const slider = document.querySelector(config.sliderSelector);
    if (!slider) return null;

    return new Swiper(slider, {
        loop: true,
        modules: [Navigation, Autoplay],
        speed: 500,
        navigation: {
            prevEl: config.prevEl,
            nextEl: config.nextEl,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            0: {
                spaceBetween: 10,
                slidesPerView: 1.3,
                centeredSlides: true,
                ...config.sp,
            },
            769: {
                spaceBetween: 40,
                slidesPerView: 2.3,
                centeredSlides: false,
                ...config.pc,
            },
        },
    });
}
